module.exports = __webpack_public_path__ + "img/kuaijie.8f9f2019.png";